import React, { Fragment, useState } from 'react';
import { IRouteModel } from '../../Routes';
import NavItem from './NavItem';
import { Colors } from '../../utils/theme';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import NavDivider from './NavDivider';
import { Collapse, Icon, List, ListItem, ListItemText, SvgIcon } from '@mui/material';
import { ExpandLess, ExpandMore, SvgIconComponent } from '@mui/icons-material';

// const useStyles = makeStyles((Theme: Theme & ITheme) => {
//   return {
//     item: {
//       height: 39,
//       width: 166,
//       paddingRight: 12,
//       paddingLeft: 15,
//       '&$selected': {
//         height: 41,
//         backgroundColor: Theme.Colors.third,
//         borderRadius: '0px 100px 100px 0px',
//         '&:hover': {
//           height: 41,
//           backgroundColor: Theme.Colors.third,
//           borderRadius: '0px 100px 100px 0px'
//         }
//       },
//       '&:hover': {
//         height: 39,
//         backgroundColor: Theme.Colors.third,
//         borderRadius: '0px 100px 100px 0px'
//       }
//     },
//     itemClosed: {
//       height: 32,
//       width: 32,
//       marginLeft: 14,
//       marginTop: 3.5,
//       marginBottom: 3.5,
//       '&$selected': {
//         backgroundColor: Theme.Colors.third,
//         borderRadius: '100px',
//         '&:hover': {
//           backgroundColor: Theme.Colors.third,
//           borderRadius: '100px'
//         }
//       },
//       '&:hover': {
//         backgroundColor: Theme.Colors.third,
//         borderRadius: '100px'
//       }
//     },
//     selected: {}
//   };
// });

type IPropType = {
  route: IRouteModel;
  selected: string;
  open: boolean;
  handleSelectedChanged(path: string): void;
};

const GroupItemsLink: React.FunctionComponent<IPropType> = (props: IPropType) => {
  const { route, handleSelectedChanged, selected, open } = props;
  //const classes = useStyles();
  const [openSubroutes, setOpenSubroutes] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    setOpenSubroutes(!openSubroutes);
  };

  const getId = () => `${route.name.replaceAll(' ', '-')}-Button`;

  return (
    <Fragment>
      <ListItem
        id={getId()}
        data-testid={getId()}
        button
        onClick={(e) => handleClick(e)}
        disableGutters={true}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: open ? 'left' : 'center',
          height: '40px',
          paddingLeft: open ? '14px' : 0
        }}
      >
        <SvgIcon component={route.icon as SvgIconComponent} sx={{ color: 'common.white' }} />
        {open && (
          <ListItemText
            id={route.name}
            style={{ color: Colors.white, margin: '8px' }}
            primary={route.name}
          />
        )}
        {open ? (
          openSubroutes ? (
            <ExpandLess style={{ color: Colors.white }} />
          ) : (
            <ExpandMore style={{ color: Colors.white }} />
          )
        ) : null}
      </ListItem>
      <NavDivider open={open} />
      <Collapse in={openSubroutes} timeout="auto" unmountOnExit>
        {/* {route !== undefined &&
          route.subRoutes !== undefined &&
          route.subRoutes[0].path !== selected && <NavDivider open={open} />} */}
        <List component="div" disablePadding>
          {route.subRoutes?.map((sr) => (
            <Fragment key={sr.name + sr.id}>
              <NavItem
                key={sr.id}
                handleSelectedChanged={handleSelectedChanged}
                selected={selected}
                open={open}
                route={sr}
                nested
              />
              {/* {route !== undefined &&
                route.subRoutes !== undefined &&
                route.subRoutes.length > index + 1 && <NavDivider open={open} />} */}
              <NavDivider open={open} />
            </Fragment>
          ))}
        </List>
      </Collapse>
    </Fragment>
  );
};

export default GroupItemsLink;
